import React from 'react';
import PropTypes from 'prop-types';
import { Text } from '@brandwatch/axiom-components';

import {DeviceTypeContext} from '../DeviceTypeContext.jsx';
import ViziaComponent from '../containers/ViziaComponent';
import SlideLayout from '../containers/SlideLayout';
import {getDistance} from '../utils/preloadState';
import './Slide.css';

class Slide extends React.Component {
  constructor(props) {
    super(props);
    this.state = {preloadState:  props.preloadState};
  }

  componentDidMount() {
    this.props.fetchColors();
  }

  static getDerivedStateFromProps(props, state) {
    if (getDistance(props.preloadState) < getDistance(state.preloadState)) {
      state.preloadState = props.preloadState;
    }
    return state;
  }

  componentDidUpdate(prevProps) {
    if (this.props.id !== prevProps.id) {
      this.props.fetchColors();
    }
  }

  render() {
    const {
      id,
      name,
      component_order,
      layout_is_flipped_vertically,
      layout_is_flipped_horizontally,
      openFullscreenDialog,
      otp,
    } = this.props;

    const {preloadState} = this.state;

    if (preloadState && getDistance(preloadState) < 3 && !this.state.renderLayout) {
      setTimeout(() => this.setState({renderLayout: true}), 400);
    }

    const loadIframes = !preloadState || this.state.renderLayout || this.props.index === 0;
    let layout;

    if (this.context.isMobile) {
      const preloadToPropagate = preloadState === 'bundle_start' ? 'bundle_data_load' : preloadState;
      const slides = component_order.map(id => {
        return (
          <ViziaComponent
            id={id}
            key={id}
            preloadState={preloadToPropagate}
            loadIframes={loadIframes}
            onClick={openFullscreenDialog}
            otp={otp}
          />
        );
      });

      const className = ['Slide--slides'];

      if (layout_is_flipped_vertically || layout_is_flipped_horizontally) {
        className.push('Slide--slides--flip-vertically');
      }
      layout = <div className={className.join(' ')}>{slides}</div>;
    } else {
      layout = <SlideLayout id={id} preloadState={preloadState} loadIframes={loadIframes}/>;
    }

    return <div className="Slide" preload-state={preloadState}>
      <Text className="Slide--title vc-bg" textSize="body" textCase="upper">{name}</Text>
      {layout}
    </div>;
  }
}

Slide.contextType = DeviceTypeContext;

Slide.propTypes = {
  id: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string
  ]),
  index: PropTypes.number,
  name: PropTypes.string,
  fetchColors: PropTypes.func,
  hidden: PropTypes.bool,
  distance: PropTypes.number,
  component_order: PropTypes.array,
  layout_is_flipped_vertically: PropTypes.bool,
  layout_is_flipped_horizontally: PropTypes.bool,
  preloadState: PropTypes.string,
  openFullscreenDialog: PropTypes.func,
  otp: PropTypes.string,
};

Slide.defaultProps = {
  component_order: [],
  layout_is_flipped_vertically: false,
  layout_is_flipped_horizontally: false,
  fetchColors: () => {}
};

export default Slide;
